/**
 * Utility functions for extracting trip details from itinerary data
 */
import dayjs from 'dayjs'

import { isEmpty } from '../general/browserHelper'

export interface TripDetails {
    destinationCity: string
    totalTravellers: number
    tripDuration: number
}

/**
 * Extracts trip details from itinerary data
 * @param itineraryData - The complete itinerary data object
 * @returns TripDetails object containing destination city, traveller count, and trip duration
 */
export const extractTripDetails = (itineraryData: any): TripDetails => {
    const { SEARCH_DETAILS = {}, FLIGHT = {} } = itineraryData || {}
    const { paxInfo = {} } = SEARCH_DETAILS || {}
    const { adults = 0, children = 0, infants = 0 } = paxInfo || {}
    const totalTravellers = adults + children + infants
    
    // Extract destination city from flight data
    const { flights = [] } = FLIGHT || {}
    const firstFlight = flights?.[0] || {}
    const { segments = [] } = firstFlight || {}
    const lastSegment = segments?.[segments?.length - 1] || {}
    const destinationCity = lastSegment?.arrivalCity || 'Destination'
    
    // Calculate trip duration using dayjs
    const getTripDuration = () => {
        if (segments?.length > 0) {
            const firstSegment = segments[0]
            const lastSegment = segments[segments.length - 1]
            const startDate = firstSegment?.formattedDepartDateTime
            const endDate = lastSegment?.formattedArrivalDateTime
            
            if (isEmpty(startDate) || isEmpty(endDate)) {
                return 5 // Default value
            }
            
            const days = dayjs(endDate)?.diff(dayjs(startDate), 'days')
            const calculatedDays = days + 1 // Include both start and end day
            
            // showing 5 days as default for insurance
            return Math.max(calculatedDays, 5)
        }
        return 5 // Default value
    }
    
    const tripDuration = getTripDuration()
    
    return {
        destinationCity,
        totalTravellers,
        tripDuration
    }
} 